import React from "react";
import AuthContainer from "../../../components/AuthContainer.js";
import { Container, Typography } from "@mui/material";
import appcolors from "../../../constants/Colors.js";
import BackButton from "../../../components/BackButton/index.js";
import ForgotForm from "./ForgotForm.js";

const ForgotPassword = () => {
  return (
    <AuthContainer>
      <BackButton />
      <Container sx={{ maxWidth: "520px !important", mt: 6 }}>
        <Typography variant="auth_h1" component={"h1"}>
          Forgot Password
        </Typography>
        <Typography variant="auth_body1" component={"p"} sx={{ mt: 0.5 }}>
          Welcome to{" "}
          <span style={{ color: appcolors.black, fontWeight: "bold" }}>
            LOBA
          </span>{" "}
          CRM, Please give us user id
        </Typography>
        <ForgotForm />
      </Container>
    </AuthContainer>
  );
};

export default ForgotPassword;
